import { AxiosError, AxiosResponse } from 'axios';

export const checkResponseStatus = (response: AxiosResponse | AxiosError | undefined): boolean => {
  if (response && Number(response.status) >= 200 && Number(response?.status) < 300) {
    return true;
  }

  return false;
};
